import { graphql } from "@/gql";

export const createWorkOrderAssignmentExpense = graphql(`
  mutation CreateWorkOrderAssignmentExpenseMutation(
    $input: CreateWorkOrderAssignmentExpenseInput!
  ) {
    createWorkOrderAssignmentExpense(input: $input) {
      id
      type
      paid_by
      paid_to
      amount
      currency
      description
      payout_amount
      receipts {
        id
        type
        amount_inc_tax
        amount_tax
        claimable_amount_inc_tax
        currency
        claimable_converted_amount_inc_tax
        converted_currency
        exchange_rate
        description
        date
        image {
          ...MediaFields
        }
      }
    }
  }
`);

export const updateWorkOrderAssignmentExpense = graphql(`
  mutation UpdateWorkOrderAssignmentExpenseMutation(
    $id: ID!
    $input: UpdateWorkOrderAssignmentExpenseInput!
  ) {
    updateWorkOrderAssignmentExpense(id: $id, input: $input) {
      id
      type
      paid_by
      paid_to
      amount
      currency
      description
      payout_amount
    }
  }
`);

export const deleteWorkOrderAssignmentExpense = graphql(`
  mutation DeleteWorkOrderAssignmentExpenseMutation($id: ID!) {
    deleteWorkOrderAssignmentExpense(id: $id) {
      id
    }
  }
`);

export const uploadExpenseReceipts = graphql(`
  mutation UploadExpenseReceiptsMutation($id: ID!, $filePaths: [String!]!) {
    uploadExpenseReceipts(id: $id, filePaths: $filePaths) {
      id
      type
      paid_by
      paid_to
      amount
      currency
      description
      payout_amount
      receipts {
        id
        type
        amount_inc_tax
        amount_tax
        claimable_amount_inc_tax
        currency
        claimable_converted_amount_inc_tax
        converted_currency
        exchange_rate
        description
        date
        image {
          ...MediaFields
        }
      }
    }
  }
`);
